import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { inputCls, Field, Panel, FormActions, errMsg } from "./ui";

const EMPTY = { name: "", region: "", faction: "" };

export default function ServersPanel({ games }) {
  const [gameId, setGameId] = useState("");
  const [servers, setServers] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (!gameId && games[0]) setGameId(games[0].id); }, [games, gameId]);

  const load = () => gameId && api.get("/servers", { params: { game_id: gameId } }).then((r) => setServers(r.data));
  useEffect(() => { load(); }, [gameId]);

  const reset = () => { setForm(EMPTY); setEditId(null); };

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const payload = { name: form.name, region: form.region || null, faction: form.faction || null };
    try {
      if (editId) await api.patch(`/servers/${editId}`, payload);
      else await api.post("/servers", { ...payload, game_id: gameId });
      toast.success(editId ? "Server diperbarui" : "Server ditambahkan");
      reset(); load();
    } catch (err) { toast.error(errMsg(err)); } finally { setSaving(false); }
  };

  const edit = (s) => { setEditId(s.id); setForm({ name: s.name, region: s.region || "", faction: s.faction || "" }); };

  return (
    <Panel title="Server, Region & Faction" testId="servers-panel">
      <Field label="Game" className="max-w-xs mb-5">
        <select data-testid="server-game-select" className={inputCls} value={gameId} onChange={(e) => { setGameId(e.target.value); reset(); }}>
          {games.map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
        </select>
      </Field>
      <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <Field label="Nama Server"><input data-testid="server-name-input" required className={inputCls} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Field>
        <Field label="Region"><input data-testid="server-region-input" className={inputCls} placeholder="mis. Asia, EU, US" value={form.region} onChange={(e) => setForm({ ...form, region: e.target.value })} /></Field>
        <Field label="Faction"><input data-testid="server-faction-input" className={inputCls} placeholder="opsional" value={form.faction} onChange={(e) => setForm({ ...form, faction: e.target.value })} /></Field>
        <FormActions editing={!!editId} onCancel={reset} saving={saving} testPrefix="server" />
      </form>
      <table className="w-full text-sm">
        <thead><tr className="text-left text-xs uppercase tracking-widest text-[#A8A8AD] border-b border-[#35353B]">
          <th className="py-2">Server</th><th className="py-2">Region</th><th className="py-2">Faction</th><th className="py-2 text-right">Aksi</th>
        </tr></thead>
        <tbody>
          {servers.map((s) => (
            <tr key={s.id} data-testid={`server-row-${s.id}`} className="border-b border-[#35353B]">
              <td className="py-3 text-[#F5F3ED]">{s.name}</td>
              <td className="py-3 text-[#A8A8AD]">{s.region || "-"}</td>
              <td className="py-3 text-[#A8A8AD]">{s.faction || "-"}</td>
              <td className="py-3 text-right"><button data-testid={`edit-server-${s.id}`} onClick={() => edit(s)} className="text-[#D4AF37] hover:underline text-xs">Ubah</button></td>
            </tr>
          ))}
          {servers.length === 0 && <tr><td colSpan="4" className="py-6 text-center text-[#A8A8AD]">Belum ada server</td></tr>}
        </tbody>
      </table>
    </Panel>
  );
}
